// 方法论、识瓜词典与口碑内容

export type MethodStep = {
  step: string;
  title: string;
  desc: string;
  icon: string;
  action: string;
};

// 吃透一个瓜的路线图（方法论页核心）
export const methodSteps: MethodStep[] = [
  {
    step: "01",
    title: "找源头",
    desc: "不急着看情绪，先定位这件事最初由谁、在哪个平台、以什么形式发出。源头决定信息性质：官方公告、媒体报道还是网友爆料，权重完全不同。",
    icon: "ri-flag-2-line",
    action: "把「谁说的」先写下来",
  },
  {
    step: "02",
    title: "建时间线",
    desc: "把事件按时间先后摊开，标注每个节点的信息来源。你会立刻发现多数争议来自「把不同时间点的说法并置」，一旦对表，逻辑就清楚一半。",
    icon: "ri-time-line",
    action: "按时间轴给节点排号",
  },
  {
    step: "03",
    title: "辨立场",
    desc: "把各方的公开表态分列出来，找出冲突点在证据还是利益。立场不同未必有人在说谎，也可能是诉求根本没对齐。",
    icon: "ri-scales-3-line",
    action: "给每种声音标上归属",
  },
  {
    step: "04",
    title: "溯源查证",
    desc: "对截图、报价、聊天记录先问「能否回到一手来源」。无法核验的内容一律视为待定，而不是默认相信或默认反驳。",
    icon: "ri-search-eye-line",
    action: "把结论分为已证实与待核实",
  },
];

export type GlossaryWord = {
  word: string;
  type: string;
  def: string;
};

// 识瓜词典（热词）
export const glossary: GlossaryWord[] = [
  { word: "辟谣", type: "动作", def: "对不实信息做出澄清。有效辟谣需要附上一手来源，而不仅是口头否认。" },
  { word: "实锤", type: "网络语", def: "指能直接指向真相的可靠证据，常用于区别于「猜测」。" },
  { word: "吃瓜", type: "网络语", def: "围观公共事件。网络语，指围观他人的公共争议，需保持克制。" },
  { word: "断章取义", type: "手法", def: "截取片段误导全貌。识破方法是对比完整上下文与前后时间点。" },
  { word: "饥饿营销", type: "商业术语", def: "通过制造稀缺感刺激购买。判断是否误导要看补货真实性与话术口径。" },
  { word: "深度合成", type: "技术术语", def: "利用 AI 生成或修改音视频。判断标准是「是否能被显著辨识」。" },
  { word: "两难境地", type: "网络语", def: "处于左右为难的困境。" },
  { word: "前情提要", type: "编排手法", def: "事件梳理里对过往背景的概括，帮助你补上关键上下文，避免误读。" },
];

export type Testimonial = {
  name: string;
  tag: string;
  text: string;
};

// 用户口碑
export const testimonials: Testimonial[] = [
  {
    name: "陈同学",
    tag: "新闻专业在读",
    text: "把一个吵了三天的话题按时间线摊开，很多误会当场就散了。这份「信息克制」值得所有围观的人学习。",
  },
  {
    name: "老周",
    tag: "互联网从业 9 年",
    text: "过去看热点只看情绪，现在习惯先到这儿看有没有时间线和溯源清单，帮我省下大量检索时间。",
  },
  {
    name: "阿May",
    tag: "内容创作者",
    text: "追过几次完整事件地图之后，我发内容前都会先分清「事实」和「我猜」。这种习惯是真的能练出来的。",
  },
  {
    name: "匿名用户",
    tag: "职场打工人",
    text: "感谢把「已证实」和「未证实」分开列。以前一句话就能让我上头，现在多问一句来源，情绪稳定多了。",
  },
];